var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16634 7.83333H10.4747L6.40801 11.9C6.08301 12.225 6.08301 12.7583 6.40801 13.0833C6.73301 13.4083 7.25801 13.4083 7.58301 13.0833L13.0747 7.59166C13.3997 7.26666 13.3997 6.74166 13.0747 6.41666L7.59134 0.916663C7.26634 0.591663 6.74134 0.591663 6.41634 0.916663C6.09134 1.24166 6.09134 1.76666 6.41634 2.09166L10.4747 6.16666H1.16634C0.708008 6.16666 0.333008 6.54166 0.333008 7C0.333008 7.45833 0.708008 7.83333 1.16634 7.83333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFull);
export default __webpack_public_path__ + "static/media/ArrowFull.7ba60eee59638b05cc5c79da77d89aee.svg";
export { ForwardRef as ReactComponent };